import React from 'react'
import LazyImage, {LazyImageProps, LazyImageType} from './LazyImage'
import AspectRatioBox from '../layout/AspectRatioBox'
import {IMAGE_FORMATS} from './imageFormats'
import isContentfulAsset from '../../utils/isContentfulAsset'

export interface ImageType extends Omit<LazyImageProps, 'placeholder' | 'original'> {
  src: string
  width?: number
  height?: number
}

const Image: React.FC<ImageType> = ({width, height, src, ...props}) => {
  const extension = src.split('.').pop().split('?')[0].split('#')[0]

  const imageType = IMAGE_FORMATS[extension] ? extension : '*'

  let placeholder

  const original: LazyImageType = {
    [imageType]: src,
  }

  // TODO: add possibility to pass placeholder in props
  if (width && height && isContentfulAsset(src)) {
    const placeholderWidth = Math.floor(width / 20)
    const placeholderHeight = Math.floor(height / 20)

    placeholder = {
      [imageType]: `${src}?w=${placeholderWidth}&h=${placeholderHeight}`,
    }

    if (extension !== 'svg') {
      original.webp = `${src}?fm=webp&q=65`
      placeholder.webp = `${src}?fm=webp&w=${placeholderWidth}&h=${placeholderHeight}&q=65`
    }
  }

  return width && height ? (
    <AspectRatioBox $width={width} $height={height}>
      <LazyImage
        width={width}
        height={height}
        original={original}
        placeholder={placeholder}
        {...props}
      />
    </AspectRatioBox>
  ) : (
    <LazyImage original={original} placeholder={placeholder} {...props} />
  )
}

export default Image
